module.exports = firebase.firestore;